import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SeoProvider } from '../../providers/seo.provider';
import { SpinnerProvider } from '../../components/spinner/spinner.provider';

// declare function require(string: any): string;
// var img1 = require("../../../assets/images/banner1.jpg");
// var img2 = require("../../../assets/images/banner2.jpg");

@Component({
  selector: 'component-thankyou',
  templateUrl: './thankyou.page.html',
  styleUrls: ['./thankyou.page.scss']
})

export class ThankYouPage {
  img1: string;
  img2: string;
  body: string;
  webPageContent: any;

    constructor(private router: Router, private seoProvider: SeoProvider, private spinner: SpinnerProvider) {
      seoProvider.setTitle("Angelcrypt | Thank You");
    }
  }



